@if (dataContext) {
  <form class="action-form contact-document-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="contact-document-form__header">
      <h2 class="contact-document-form__title">{{ 'LEASE_AGREEMENT_DOCUMENT.FORM_HEADER' | translate }}</h2>
      <p class="contact-document-form__context">{{ 'COMMON.CONTACT' | translate }}: {{ dataContext.name }}</p>
    </div>
    <div class="contact-document-form__upload">
      <app-single-file-upload (filesSelected)="onFileChange($event)"></app-single-file-upload>
    </div>
    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
      <astral-input [control]="form.controls['caption']"></astral-input>
      <astral-select [control]="form.controls['connectionType']" [itemsSource]="connectionTypes"></astral-select>
    </astral-layout-group>
    <div class="contact-document-form__actions">
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
      <astral-button type="submit" labelKey="SAVE_BTN"></astral-button>
    </div>
  </form>
}
